import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import PopupBasicLazy from 'src/game/components/popups/PopupBasicLazy';
import { AssetGroup } from '@play-co/timestep-core';
import { downscale } from 'src/conf/scale';

const ui = uiConfig.buruburu.invite.confirm;
type CloseHandler = (accepted: boolean) => void;

export default class PopupPNPermission extends PopupBasicLazy {
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      height: 550,
      tracking: {
        feature: Feature.PUSH_NOTIFICATION._,
        $subFeature: Feature.PUSH_NOTIFICATION.PERMISSION_POPUP._,
      },
    });

    this.message.updateOpts({
      ...ui.message,
      width: 450,
      height: 100,
      x: (550 - 450) / 2,
      y: 310,
    });

    new ImageScaleView({
      superview: this.box,
      width: downscale(578),
      height: downscale(292),
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 200,
      image: `assets/ui/pushnotification/new/push_notification.png`,
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...ui.okButton,
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 480,
      localeText: () => i18n('pushNotification.permissionV2.turnOn'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: {
        feature: Feature.PUSH_NOTIFICATION._,
        $subFeature: Feature.PUSH_NOTIFICATION.PERMISSION_POPUP.OK,
      },
    });
  }

  protected getAssetsGroup(): AssetGroup {
    return new AssetGroup([
      'assets/ui/pushnotification/new/push_notification.png',
    ]);
  }

  public init() {
    super.init({
      title: i18n('pushNotification.permissionV2.title'),
      message: i18n('pushNotification.permissionV2.message'),
    });
  }
}
